export default __webpack_public_path__ + "static/floor2-slide-6-011ed13f84c143a412bb87dbce5081b0.jpg";